import getProfileHandler from "@/interface/api/getProfile";

import { userProfileApiToDataTransformer } from "./UserService";

import { logServerError } from "@/services/DatadogService/serverLogger";
import { isAuthenticationError } from "@/utils/errorUtils";

import type { UserProps } from "@/types/user";

/**
 * Fetches and transforms the viewer's profile for server components.
 *
 * Returns `null` instead of throwing so callers can treat any unresolvable session
 * (expired token, profile API down) as an anonymous viewer and route accordingly.
 * Auth failures are the expected way an expired cookie surfaces, so only non-auth
 * errors are logged.
 */
export const getServerUserProfile = async ({
  token,
  origin,
}: {
  token: string;
  origin: string;
}): Promise<UserProps | null> => {
  try {
    const profileResponse = await getProfileHandler.getProfile({ authorization: token, origin });
    return userProfileApiToDataTransformer(profileResponse.data) ?? null;
  } catch (error) {
    if (!isAuthenticationError(error)) {
      logServerError(error instanceof Error ? error : new Error(String(error)), {
        component: "getServerUserProfile",
        action: "getProfile",
        context: { origin },
      });
    }
    return null;
  }
};
